// All content, trademarks, and data on this document are the property of Healthworks Analytics, LLC and are protected by applicable intellectual property laws. Unauthorized use, reproduction, or distribution of this material is strictly prohibited.
import { useEffect } from 'react';

const FrameProtection = () => {
  useEffect(() => {
    function preventFraming() {
      try {
        if (window.self !== window.top) {
          // modify our own location
          window.self.location.href = window.self.location.href;
        }

        // secondary check
        if (window.top.location.hostname !== window.self.location.hostname) {
          window.self.location.href = window.self.location.href;
        }
      } catch (e) {
        // we're definitely being framed (cross-origin)
        // redirect to our current URL
        window.self.location.href = window.self.location.href;
      }
    }

    preventFraming();
  }, []);

  return null;
};

export default FrameProtection;